import {styled} from "styled-components";
import {Button, Card} from "antd";

export const StyledApproveButton = styled(Button)`
    width: 100%;
    background-color: #16c416;
    color: white;
    border: none;
`;
export const StyledRejectButton = styled(Button)`
    width: 100%;
    background: #ce1919;
    color: white;
    border: none;
`;